import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const AddMainCategory = () => {
  const [formData, setFormData] = useState({
    name: '',
    status: '1'
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await postRequest('main-categories', formData);
      toast.success('Main category added successfully!', {
        position: 'top-right',
        autoClose: 2000
      });
      setTimeout(() => {
        navigate('/main-categories');
      }, 2000);
    } catch (error) {
      console.error('Failed to add main category:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Main Category</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                placeholder="Enter main category name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>

          <button type="submit" className="btn addbtn mt-3">
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddMainCategory;
